(function($) {
	
	const $block = $('.wp-block-metropolis-carousel');
	
	$block.each( function() {
		
		let $container = $(this);
		let selector = '.wp-block-metropolis-carousel';
		const looped = $container.hasClass('is-looped');
		const $children = $container.children().children();
		const id = $container.attr('id');
		
		if( $children.first().is('.wp-block-metropolis-posts-block') ) {
			$container = $children;
			selector = '.wp-block-metropolis-posts-block';
		} 
	
		$container.addClass('swiper').children().addClass('swiper-wrapper').children().addClass('swiper-slide').ready(function () {
			
			const $el = $container[0];
			let blockGap = getComputedStyle($el).getPropertyValue('--carousel-block-gap');
			
			if( ['em', 'rem'].some(el => blockGap.includes(el)) ) {
				const baseFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
				const value = blockGap
					.replaceAll('rem', '')
    				.replaceAll('em', '');
				blockGap = value*baseFontSize + "px";
			}
			
			const carousel = new Swiper($el, {
				
				slidesPerView: 'auto',
				spaceBetween: blockGap,
    			containerModifierClass: 'carousel-',
				loop: looped,
				navigation: {
					nextEl: '.wp-block-metropolis-carousel-navigation[data-carousel-id="' + id + '"] .next',
					prevEl: '.wp-block-metropolis-carousel-navigation[data-carousel-id="' + id + '"] .prev',
					disabledClass: 'disabled',
					hiddenClass: 'hidden',
				},
				pagination: {
					el: '.wp-block-metropolis-carousel-pagination[data-carousel-id="' + id + '"]',
    				type: 'bullets',
					clickable: true,
				},
				
			});
			
		});
	
	});
	
})(jQuery);